export default __webpack_public_path__ + "static/media/pic9.12088b34.jpg";